var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination" },
    [
      _vm.historyPageToken && _vm.queryResponse
        ? _c(
            "b-button-group",
            [
              _vm.historyPageToken.list[_vm.historyPageToken.index]
                ? _c("b-button", { on: { click: _vm.goFirst } }, [
                    _c("i", { staticClass: "mdi mdi-page-first" }),
                    _vm._v("First"),
                  ])
                : _vm._e(),
              _vm.historyPageToken.list[_vm.historyPageToken.index]
                ? _c(
                    "b-button",
                    { attrs: { hidden: "" }, on: { click: _vm.goPrev } },
                    [
                      _c("i", { staticClass: "mdi mdi-page-first" }),
                      _vm._v("Prev"),
                    ]
                  )
                : _vm._e(),
              _vm.queryResponse.next_page_token
                ? _c("b-button", { on: { click: _vm.goNext } }, [
                    _vm._v("Next"),
                    _c("i", { staticClass: "mdi mdi-arrow-right" }),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }